import React, {Component, createRef} from 'react';
import CountUp from 'react-countup';

class Count extends Component {
    constructor({
        prefix = false,
        suffix = false,
        decimals = 2,
        duration = 1
    }) {
        super();

        this.prefix = prefix;
        this.suffix = suffix;
        this.decimals = decimals;
        this.duration = duration;

        this.state = {
            from: 0,
            to: 0
        }
    }

    render() {
        let {from, to} = this.state;

        return (
            <CountUp
                start={from}
                end={to}
                duration={this.duration}
                decimals={this.decimals}
                separator={','}>
                {({countUpRef}) => (
                    <span>
                        {this.prefix}<span ref={countUpRef}></span>{this.suffix}
                    </span>
                )}
            </CountUp>
        )
    }

    componentDidUpdate(prevProps) {
        const prev_value = prevProps.value,
              curr_value = this.props.value;

        if(prev_value !== curr_value)
            this.setState({
                from: prev_value,
                to: curr_value
            });
    }

    componentDidMount() {
        this.setState({
            from: 0,
            to: this.props.value
        })
    }
}

export default Count;